import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { ClassInsightsStoreModel } from './class-insights.model';

export type ClassInsightsState = EntityState<ClassInsightsStoreModel>;

@Injectable({ providedIn: 'root' })
export class ClassInsightsStore extends EntityStore<ClassInsightsState, ClassInsightsStoreModel, 'classId'> {
  constructor() {
    super({
      name: 'class-insights',
      idKey: 'classId',
    });
  }
}
